const SvgPoint = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={16}
        height={16}
        fill='none'
        stroke='{{replacement-value-color}}'
        strokeLinecap='round'
        strokeWidth={8}
        viewBox='0 0 100 100'
    >
        <circle cx={50} cy={50} r={7} />
    </svg>
);
export default SvgPoint;
